import React, { useContext, useReducer, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormDataContext } from "./FormDataContext";
import "../Style/Page1.css";

const TEN_MINUTES_MS = 10 * 60 * 1000;

const safeParseJSON = (raw) => {
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

const getSavedFormData = () => {
    const savedData = safeParseJSON(sessionStorage.getItem("page1FormData"));
    const savedTime = sessionStorage.getItem("page1FormTime");
    const currentTime = new Date().getTime();

    if (savedData && savedTime && currentTime - parseInt(savedTime, 10) < TEN_MINUTES_MS) {
        return { ...savedData, errors: {} };
    }

    return {
        citizenship: "",
        errors: {},
    };
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_CITIZENSHIP":
            return { ...state, citizenship: action.payload };
        case "SET_ERRORS":
            return { ...state, errors: action.payload };
        default:
            return state;
    }
};

const CITIZENSHIP_OPTIONS = [
    { label: "ՀՀ", value: "ՀՀ" },
    { label: "Այլ", value: "Այլ" },
];

const Page1 = () => {
    const navigate = useNavigate();
    const { updateFormData } = useContext(FormDataContext);
    const [state, dispatch] = useReducer(reducer, getSavedFormData());
    const [activeDropdown, setActiveDropdown] = useState(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (state.citizenship) {
            sessionStorage.setItem("page1FormData", JSON.stringify(state));
            sessionStorage.setItem("page1FormTime", new Date().getTime().toString());
        }
    }, [state]);

    useEffect(() => {
        const timer = setTimeout(() => {
            sessionStorage.removeItem("page1FormData");
            sessionStorage.removeItem("page1FormTime");
            dispatch({ type: "SET_CITIZENSHIP", payload: "" });
            dispatch({ type: "SET_ERRORS", payload: {} });
        }, TEN_MINUTES_MS);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setActiveDropdown(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const validateFields = () => {
        const newErrors = {};
        if (!state.citizenship) newErrors.citizenship = "Խնդրում ենք նշել քաղաքացիությունը";
        dispatch({ type: "SET_ERRORS", payload: newErrors });
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (validateFields()) {
            updateFormData({ citizenship: state.citizenship });
            navigate("/page2");
        }
    };

    return (
        <div className="page1 page">
            <div className="container">
                <h1>Դասընթացների գրանցում</h1>
                <h3 className="title1">
                    Խնդրում ենք լրացնել ողջ տեղեկատվությունը հայատառ, այլապես Ձեր հարցումը կարող է մերժվել
                </h3>
                <Dropdown
                    label="Նշել քաղաքացիությունը"
                    selected={state.citizenship || "Նշել քաղաքացիությունը"}
                    options={CITIZENSHIP_OPTIONS}
                    onSelect={(value) => dispatch({ type: "SET_CITIZENSHIP", payload: value })}
                    activeDropdown={activeDropdown}
                    setActiveDropdown={setActiveDropdown}
                    type="citizenship"
                    dropdownRef={dropdownRef}
                />
                {state.errors.citizenship && (
                    <p className="error-text">{state.errors.citizenship}</p>
                )}
                <button className="submit-btn" onClick={handleSubmit}>Հաջորդ էջ</button>
            </div>
        </div>
    );
};

const Dropdown = ({
                      label,
                      selected,
                      options,
                      onSelect,
                      activeDropdown,
                      setActiveDropdown,
                      type,
                      dropdownRef
                  }) => (
    <div className="form-group" ref={dropdownRef}>
        <label>{label}</label>
        <div
            className={`custom-dropdown input-like ${activeDropdown === type ? "active" : ""}`}
            onClick={() => setActiveDropdown(activeDropdown === type ? null : type)}
        >
            <div className="dropdown-selected">{selected}</div>
            <div className="dropdown-options">
                {options.map((opt) => (
                    <div
                        key={opt.value}
                        className="dropdown-item"
                        onClick={(e) => {
                            e.stopPropagation();
                            onSelect(opt.value);
                            setActiveDropdown(null);
                        }}
                    >
                        {opt.label}
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default Page1;
